{
  "portal.title": "بوابة العملاء",
  "portal.shell.account": "حسابك",
  "portal.shell.signOut": "تسجيل الخروج",
  "portal.shell.home": "الصفحة الرئيسية لمشاريعك",
  "portal.shell.switchLanguage": "التبديل إلى الإنجليزية",
  "portal.shell.otherLanguage": "English",
  "portal.shell.footer": "© 404 Creative · صُنع بعناية في القاهرة ودبي",
  "portal.shell.secure": "خاص بك وبفريق 404 Creative فقط.",
  "portal.auth.kicker": "بوابة عملاء 404 Creative",
  "portal.auth.headline": "مشروعك، واضح من أول نظرة.",
  "portal.auth.point.journey": "تابع كل محطة والمراحل التي تمر بها.",
  "portal.auth.point.approve": "راجع واعتمد التصاميم والمحطات بضغطة واحدة.",
  "portal.auth.point.talk": "تواصل مع الفريق في نفس مكان العمل.",
  "portal.auth.preview.kickoff": "الانطلاق",
  "portal.auth.preview.firstLook": "النظرة الأولى",
  "portal.auth.preview.launch": "الإطلاق",
  "portal.auth.preview.handover": "التسليم",
  "portal.auth.preview.wireframes": "المخططات الأولية",
  "portal.auth.preview.visuals": "التصميم المرئي",
  "portal.auth.preview.review": "المراجعة",
  "portal.signIn.title": "أهلاً بعودتك",
  "portal.signIn.subtitle": "سجّل الدخول لمتابعة مشاريعك مع 404 Creative.",
  "portal.signIn.email": "البريد الإلكتروني",
  "portal.signIn.submit": "تسجيل الدخول",
  "portal.signIn.invalid": "البريد الإلكتروني وكلمة المرور غير متطابقين. تأكد منهما وحاول مرة أخرى.",
  "portal.signIn.rateLimited": "محاولات كثيرة. انتظر بضع دقائق ثم حاول مرة أخرى.",
  "portal.signIn.help": "لم تحدد كلمة مرور بعد؟ استخدم رابط الدعوة الذي أرسلناه لك، أو اطلب رابطاً جديداً من مدير مشروعك.",
  "portal.reset.title": "إعادة تعيين كلمة مرور البوابة",
  "portal.reset.subtitle": "اكتب البريد الإلكتروني الذي تستخدمه للبوابة. إن كان لدينا فسنرسل رمزاً من أربعة أرقام.",
  "portal.reset.sentTitle": "تحقق من بريدك",
  "portal.reset.sentSubtitle": "أدخل الرمز المكوّن من أربعة أرقام الذي أرسلناه إلى {email}.",
  "portal.reset.newTitle": "اختر كلمة مرور جديدة",
  "portal.reset.newSubtitle": "بعدها ستدخل البوابة، وتُسجَّل خروجك من أجهزتك الأخرى.",
  "portal.invitation.title": "أهلاً بك في بوابتك",
  "portal.invitation.subtitle": "دعاك {name} لمتابعة مشاريعك مع 404 Creative. اختر كلمة مرور للبدء.",
  "portal.invitation.subtitleNoInviter": "أنت مدعو لمتابعة مشاريعك مع 404 Creative. اختر كلمة مرور للبدء.",
  "portal.invitation.name": "اسمك",
  "portal.invitation.password": "اختر كلمة مرور",
  "portal.invitation.passwordHint": "{count, plural, zero {# حرف على الأقل.} one {حرف واحد على الأقل.} two {حرفان على الأقل.} few {# أحرف على الأقل.} many {# حرفاً على الأقل.} other {# حرف على الأقل.}}",
  "portal.invitation.accept": "افتح بوابتي",
  "portal.invitation.accepting": "جارٍ الفتح…",
  "portal.invitation.goToSignIn": "الذهاب لتسجيل الدخول",
  "portal.invitation.expired.title": "انتهت صلاحية هذه الدعوة",
  "portal.invitation.invalid.title": "رابط الدعوة هذا غير صالح",
  "portal.invitation.gone.body": "اطلب رابطاً جديداً من مدير مشروعك في 404 Creative. وإن كنت اخترت كلمة مرور من قبل، فسجّل الدخول مباشرة.",
  "portal.notFound.title": "لم نجد هذه الصفحة",
  "portal.notFound.body": "ربما نُقلت، أو أنها غير مشتركة معك.",
  "portal.notFound.home": "العودة إلى مشاريعك",
  "portal.home.title": "الرئيسية",
  "portal.home.greeting": "{greeting, select, morning {صباح الخير} afternoon {مساء الخير} other {مساء الخير}} يا {name}",
  "portal.home.intro": "هنا تجد آخر ما وصل إليه عملك مع 404 Creative اليوم.",
  "portal.home.tile.action": "بانتظارك",
  "portal.home.tile.projects": "المشاريع",
  "portal.home.tile.progress": "التقدم العام",
  "portal.home.needsAction": "يحتاج إجراءً منك",
  "portal.home.caughtUp": "لا شيء بانتظارك",
  "portal.home.caughtUpBody": "سنخبرك عندما يحتاج شيء إلى اعتمادك.",
  "portal.home.projects": "مشاريعك",
  "portal.home.noProjects": "لا توجد مشاريع بعد",
  "portal.home.noProjectsBody": "ستظهر مشاريعك هنا بمجرد أن يبدأها الفريق.",
  "portal.home.updates": "آخر التحديثات",
  "portal.home.noUpdates": "لا جديد بعد",
  "portal.home.noUpdatesBody": "تظهر هنا الملفات المشتركة والاعتمادات والمحطات.",
  "portal.home.loadError": "تعذر تحميل مشاريعك.",
  "portal.update.approvalRequested": "طُلب اعتمادك على {title}",
  "portal.update.approvalDecided": "{status, select, approved {تم اعتماد {title}} changes_requested {طُلبت تعديلات على {title}} other {تم البت في {title}}}",
  "portal.update.milestoneReached": "تم بلوغ محطة: {title}",
  "portal.update.fileShared": "ملف جديد مشترك: {title}",
  "portal.service.web": "موقع إلكتروني",
  "portal.service.mobile": "تطبيق موبايل",
  "portal.service.automation": "أتمتة",
  "portal.service.marketing": "تسويق",
  "portal.phase.strategy": "الاستراتيجية",
  "portal.phase.design": "التصميم",
  "portal.phase.build": "التنفيذ",
  "portal.phase.grow": "النمو",
  "portal.journey.label": "رحلة المشروع",
  "portal.journey.currentLabel": "رحلة المشروع، الآن في محطة {label}",
  "portal.journey.now": "الآن",
  "portal.journey.state.done": "مكتملة",
  "portal.journey.state.current": "قيد التنفيذ",
  "portal.journey.state.upcoming": "قادمة",
  "portal.journey.range": "{start} – {end}",
  "portal.journey.phases": "المراحل",
  "portal.journey.noPhases": "لم يقسّم الفريق هذه المحطة إلى مراحل بعد.",
  "portal.project.back": "كل المشاريع",
  "portal.project.due": "موعد التسليم {date}",
  "portal.project.progress": "تم إنجاز {percent}",
  "portal.project.nextMilestone": "المحطة القادمة",
  "portal.project.noMilestone": "تم بلوغ كل المحطات",
  "portal.project.nowIn": "الجاري الآن",
  "portal.project.views": "عروض المشروع",
  "portal.project.tab.milestones": "المحطات",
  "portal.project.tab.work": "الأعمال المشتركة",
  "portal.project.tab.files": "الملفات",
  "portal.project.noMilestones": "لا توجد محطات بعد",
  "portal.project.noMilestonesBody": "يضيف الفريق محطات المشروع أثناء التخطيط.",
  "portal.project.noWork": "لا شيء مشترك بعد",
  "portal.project.noWorkBody": "عندما يشاركك الفريق جزءاً من العمل، يمكنك متابعته ومناقشته هنا.",
  "portal.project.noFiles": "لا توجد ملفات بعد",
  "portal.project.noFilesBody": "تظهر هنا التصاميم والمستندات والتسليمات التي يشاركها الفريق معك.",
  "portal.project.loadError": "تعذر تحميل هذا المشروع.",
  "portal.milestone.done": "تم بلوغها",
  "portal.milestone.active": "جارية",
  "portal.milestone.late": "متأخرة",
  "portal.milestone.upcoming": "قادمة",
  "portal.milestone.dueOn": "مخطط لها في {date}",
  "portal.milestone.reachedOn": "تم بلوغها في {date}",
  "portal.stage.planned": "مخطط",
  "portal.stage.in_progress": "قيد التنفيذ",
  "portal.stage.done": "منجز",
  "portal.task.due": "موعده {date}",
  "portal.task.panel": "عمل مشترك",
  "portal.task.files": "الملفات",
  "portal.task.discussion": "النقاش",
  "portal.task.noComments": "لا رسائل بعد. اطرح سؤالاً أو شارك ملاحظاتك مع الفريق.",
  "portal.task.loadError": "تعذر تحميل هذا العمل.",
  "portal.comment.client": "فريقك",
  "portal.comment.team": "404 Creative",
  "portal.comment.someone": "شخص ما",
  "portal.composer.label": "رسالة إلى الفريق",
  "portal.composer.placeholder": "اكتب للفريق… اختر اسماً بالأسفل للإشارة إلى شخص",
  "portal.composer.attach": "إرفاق",
  "portal.composer.mention": "أشِر إلى شخص",
  "portal.composer.removeFile": "إزالة {name}",
  "portal.composer.send": "إرسال",
  "portal.composer.sending": "جارٍ الإرسال…",
  "portal.composer.sendError": "تعذر إرسال رسالتك. حاول مرة أخرى.",
  "portal.composer.uploadError": "تعذر رفع {name}.",
  "portal.files.openError": "تعذر فتح هذا الملف. حاول مرة أخرى.",
  "portal.due.today": "مطلوب اليوم",
  "portal.due.inDays": "{days, plural, zero {مطلوب اليوم} one {مطلوب غداً} two {مطلوب خلال يومين} few {مطلوب خلال # أيام} many {مطلوب خلال # يوماً} other {مطلوب خلال # يوم}} · {date}",
  "portal.due.late": "{days, plural, zero {متأخر} one {متأخر يوماً واحداً} two {متأخر يومين} few {متأخر # أيام} many {متأخر # يوماً} other {متأخر # يوم}}",
  "portal.approval.review": "مراجعة",
  "portal.approval.approve": "اعتماد",
  "portal.approval.requestChanges": "طلب تعديلات",
  "portal.approval.askedBy": "طلبه {name} {when}",
  "portal.approval.askedOn": "طلبه {name} في {date}",
  "portal.approval.decidedOn": "بتّ فيه {name} في {date}",
  "portal.approval.round": "الجولة {number}",
  "portal.approval.status.pending": "بانتظار القرار",
  "portal.approval.status.approved": "معتمد",
  "portal.approval.status.changes_requested": "طُلبت تعديلات",
  "portal.approval.status.cancelled": "مسحوب",
  "portal.approval.previewAlt": "معاينة {title}",
  "portal.approval.noInlinePreview": "افتح الملف لمراجعته.",
  "portal.approval.version": "الإصدار {version}",
  "portal.approval.openFile": "فتح الملف",
  "portal.approval.openPdf": "فتح ملف PDF",
  "portal.approval.milestone": "محطة",
  "portal.approval.milestoneIn": "محطة · {label}",
  "portal.approval.workDone": "العمل المنجز",
  "portal.approval.message": "رسالة من الفريق",
  "portal.approval.noMessage": "لم تُضف رسالة.",
  "portal.approval.history": "الجولات",
  "portal.approval.waitingTitle": "بانتظار القرار",
  "portal.approval.waitingOn": "هذا بانتظار {name}.",
  "portal.approval.approvedTitle": "تم الاعتماد",
  "portal.approval.changesTitle": "طُلبت تعديلات",
  "portal.approval.changesBody": "طلب {name} تعديلات في {date}. سيشارك الفريق جولة جديدة.",
  "portal.approval.cancelledBody": "سحب الفريق هذا الطلب.",
  "portal.approval.loadError": "تعذر تحميل طلب الاعتماد هذا.",
  "portal.decision.prompt": "قرارك",
  "portal.decision.promptBody": "اعتمد ليكمل الفريق العمل، أو أخبرهم بما يجب تعديله.",
  "portal.decision.approveTitle": "اعتماد هذا؟",
  "portal.decision.approveBody": "أنت تعتمد {title} كما هو معروض. سيصل الإشعار للفريق فوراً.",
  "portal.decision.changesTitle": "طلب تعديلات",
  "portal.decision.changesBody": "أخبر الفريق بما يجب تعديله في {title}. سيردون بجولة جديدة.",
  "portal.decision.noteLabel": "أضف ملاحظة (اختياري)",
  "portal.decision.notePlaceholder": "أي شيء يجب أن يعرفه الفريق",
  "portal.decision.changesLabel": "ما الذي يجب تعديله؟",
  "portal.decision.changesPlaceholder": "مثال: كبّروا الشعار واستخدموا الألوان الأدفأ",
  "portal.decision.changesRequired": "أخبر الفريق بما يجب تعديله.",
  "portal.decision.confirmApprove": "اعتماد",
  "portal.decision.sendChanges": "إرسال التعديلات",
  "portal.decision.sending": "جارٍ الإرسال…",
  "portal.decision.approvedToast": "تم الاعتماد. شكراً لك!",
  "portal.decision.changesSent": "تم إرسال تعديلاتك إلى الفريق.",
  "portal.decision.error": "تعذر تسجيل قرارك. حاول مرة أخرى.",
  "approvals.title": "الاعتمادات",
  "approvals.subtitle": "ما طُلب من العميل اعتماده، وكم انتظر العمل ردّه.",
  "approvals.loadError": "تعذر تحميل الاعتمادات.",
  "approvals.tile.waiting": "بانتظار العميل",
  "approvals.tile.waitingDays": "{count, plural, zero {# يوم} one {يوم واحد} two {يومان} few {# أيام} many {# يوماً} other {# يوم}}",
  "approvals.tile.waitingHours": "{count, plural, zero {# ساعة} one {ساعة واحدة} two {ساعتان} few {# ساعات} many {# ساعة} other {# ساعة}}",
  "approvals.tile.pending": "قيد الانتظار",
  "approvals.tile.approved": "معتمدة",
  "approvals.tile.changes": "طُلبت تعديلات",
  "approvals.filter.label": "تصفية الاعتمادات",
  "approvals.filter.all": "الكل",
  "approvals.status.pending": "قيد الانتظار",
  "approvals.status.approved": "معتمد",
  "approvals.status.changes_requested": "طُلبت تعديلات",
  "approvals.status.cancelled": "ملغى",
  "approvals.round": "الجولة {number}",
  "approvals.empty.title": "لا اعتمادات هنا",
  "approvals.empty.body": "أرسل تصميماً أو مرحلة إلى العميل ليعتمدها من بوابته.",
  "approvals.help.title": "كيف تعمل الاعتمادات",
  "approvals.help.snapshot": "يُحفظ ما ترسله كما هو الآن. أي رفع جديد لاحقاً لا يغيّر ما اعتمده العميل.",
  "approvals.help.rounds": "عندما يطلب العميل تعديلات، رُدّ بجولة جديدة: يحتفظ السجل بكل جولة وتعليق.",
  "approvals.help.clock": "يجمع عدّاد انتظار العميل الوقت الذي انتظره كل طلب حتى الرد.",
  "approvals.row.asked": "طُلب من {name} {when}",
  "approvals.row.due": "مطلوب {date}",
  "approvals.row.waitedDays": "{count, plural, zero {انتظر # يوم} one {انتظر يوماً واحداً} two {انتظر يومين} few {انتظر # أيام} many {انتظر # يوماً} other {انتظر # يوم}}",
  "approvals.row.waitedHours": "{count, plural, zero {انتظر أقل من ساعة} one {انتظر ساعة واحدة} two {انتظر ساعتين} few {انتظر # ساعات} many {انتظر # ساعة} other {انتظر # ساعة}}",
  "approvals.row.newRound": "جولة جديدة",
  "approvals.row.roundSent": "تم إرسال جولة جديدة للعميل.",
  "approvals.row.cancel": "إلغاء الطلب",
  "approvals.row.cancelTitle": "إلغاء هذا الطلب؟",
  "approvals.row.cancelBody": "لن يُطلب من العميل اعتماد {title} بعد الآن.",
  "approvals.nextRound.title": "إرسال جولة جديدة",
  "approvals.nextRound.description": "يرى العميل الإصدار الجديد في بوابته ويقرر من جديد.",
  "approvals.nextRound.clientComment": "ما طلبه العميل",
  "approvals.nextRound.versions": "رُفض الإصدار {rejected}. سيُرسل الإصدار {sent}.",
  "approvals.nextRound.sameVersionTitle": "ارفع الملف المعدّل أولاً",
  "approvals.nextRound.sameVersionBody": "الإصدار {version} هو الذي رفضه العميل. ارفع الملف المعدّل كإصدار جديد، ثم أرسل الجولة.",
  "approvals.nextRound.messageLabel": "ما الذي تغيّر؟",
  "approvals.nextRound.submit": "إرسال للعميل",
  "approvals.nextRound.sending": "جارٍ الإرسال…",
  "approvals.request.open": "طلب اعتماد",
  "approvals.request.title": "طلب اعتماد",
  "approvals.request.description": "يعتمده العميل من بوابته. يُحفظ ما ترسله كما هو الآن.",
  "approvals.request.subjectKind": "ما المطلوب اعتماده",
  "approvals.subject.file": "ملف",
  "approvals.subject.milestone": "مرحلة",
  "approvals.request.pickFile": "الملف",
  "approvals.request.pickMilestone": "المرحلة",
  "approvals.request.pickPlaceholder": "اختر…",
  "approvals.request.fileOption": "{name} (الإصدار {version})",
  "approvals.request.milestoneOption": "{name} · {date}",
  "approvals.request.titleLabel": "العنوان",
  "approvals.request.messageLabel": "رسالة إلى العميل",
  "approvals.request.messageHint": "ما الذي يجب أن ينظروا إليه؟ اجعلها قصيرة وودودة.",
  "approvals.request.dueLabel": "الرد قبل",
  "approvals.request.duePlaceholder": "بدون تاريخ",
  "approvals.request.approvers": "من يعتمد",
  "approvals.request.noApprovers": "لا أحد من هذا العميل يستخدم البوابة بعد. ادعُ جهة اتصال من صفحة العميل أولاً.",
  "approvals.request.submit": "إرسال للاعتماد",
  "approvals.request.sending": "جارٍ الإرسال…",
  "approvals.request.sent": "تم الإرسال. سيظهر للعميل في بوابته.",
  "approvals.error.needsClient": "يمكن إرسال أعمال مشاريع العملاء فقط للاعتماد.",
  "approvals.error.approvers": "اختر من يعتمد من بين أشخاص العميل على البوابة.",
  "approvals.error.round": "الجولة الجديدة ترد على طلب تعديلات، مرة واحدة.",
  "approvals.error.sameVersion": "ارفع الملف المعدّل قبل إرسال جولة جديدة.",
  "approvals.error.closed": "هذا الطلب مغلق بالفعل.",
  "approvals.error.permission": "ليست لديك صلاحية للقيام بذلك.",
  "approvals.error.noWhatsApp": "لا يوجد رقم واتساب أو هاتف لأي من المعتمدين. أضف رقماً إلى جهة الاتصال.",
  "approvals.whatsapp.share": "واتساب",
  "approvals.whatsapp.hint": "افتح واتساب برسالة جاهزة بلغة العميل",
  "approvals.share.label": "مشاركة مع العميل",
  "approvals.share.on": "مشترك مع العميل",
  "approvals.share.off": "مشاركة مع العميل",
  "approvals.share.onHint": "يرى العميل هذا في بوابته. اضغط لإبقائه داخل الفريق.",
  "approvals.share.offHint": "يراه الفريق فقط. اضغط لإظهاره في بوابة العميل.",
  "approvals.share.sharedToast": "تمت المشاركة مع العميل.",
  "approvals.share.hiddenToast": "أصبح مرئياً للفريق فقط.",
  "approvals.share.noClient": "هذا مشروع داخلي: لا يوجد عميل للمشاركة معه.",
  "approvals.share.error": "تعذر تغيير من يرى هذا. حاول مرة أخرى.",
  "approvals.access.active": "على البوابة",
  "approvals.access.invited": "مدعو",
  "approvals.access.invite": "دعوة إلى البوابة",
  "approvals.access.resend": "رابط جديد",
  "approvals.access.revoke": "إغلاق الوصول للبوابة",
  "approvals.access.revokeTitle": "إغلاق الوصول للبوابة؟",
  "approvals.access.revokeBody": "سيُسجَّل خروج {name} فوراً ولن يتمكن من فتح البوابة.",
  "approvals.access.revoked": "تم إغلاق الوصول للبوابة.",
  "approvals.access.dialogTitle": "دعوة إلى بوابة العملاء",
  "approvals.access.dialogBody": "سيحصل {name} على رابط لاختيار كلمة مرور ومتابعة مشاريعه.",
  "approvals.access.create": "إنشاء الدعوة",
  "approvals.access.sending": "جارٍ الإنشاء…",
  "approvals.access.created": "الدعوة جاهزة. أرسل هذا الرابط لهم (يعمل مرة واحدة لمدة 7 أيام).",
  "approvals.access.link": "رابط الدعوة",
  "approvals.access.done": "تم",
  "approvals.access.needsEmail": "أضف بريداً إلكترونياً لجهة الاتصال أولاً.",
  "approvals.access.emailTaken": "هذا البريد مستخدم بالفعل لشخص آخر.",
  "approvals.role.admin": "مسؤول لدى العميل",
  "approvals.role.member": "عضو لدى العميل",
  "approvals.access.emailed": "أرسلنا الدعوة بالبريد. ويمكنك أيضًا إرسال هذا الرابط لهم (يعمل مرة واحدة لمدة ٧ أيام)."
}
